import {defineNuxtPlugin} from '#imports';
import {useABTestStore} from '../store/ab-test.store';

/**
 * Used to fetch all campaigns automatically
 */
export default defineNuxtPlugin({
    name: 'nuxt-features-module-load-abtest-campaigns',
    parallel: true,
    dependsOn: ['fetch-auth'],
    setup: async () => {
        const {init} = useABTestStore();

        await init();
    },
});
